module.exports = "fragment MarketingMultiParagraphFragment on MarketingMultiParagraph {\n  __typename\n  createdAt\n  updatedAt\n  id\n  title\n  content\n}\n"